export default {
  new_module: '/module/api/new',
  update_module: '/module/api/update',
  search_module: '/module/api/search',
  delete_module: '/module/api/delete',
};
